import { makeStyles } from '@mui/styles';
import * as colors from 'apollo-react/colors';
import Grid from 'apollo-react/components/Grid';
import Typography from 'apollo-react/components/Typography';
import classNames from 'classnames';
import React from 'react';

import { dateLabelByStatus, formatStatus, userLabelByStatus } from './propTransformations';
import { formatMoment } from '../../utils/dateUtils';
import * as rUtils from '../../utils/ramdaUtils';
import withTranslation from '../withTranslation';

const useStyles = makeStyles({
  root: {
    minWidth: 260,
    maxWidth: 360,
  },
  label: {
    color: colors.black,
    fontSize: 16,
    fontWeight: 600,
    lineHeight: 1.5,
    display: 'block',
  },
  field: {
    color: colors.black,
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.5,
    display: 'block',
  },
  value: {
    color: colors.neutral7,
    fontSize: 14,
    lineHeight: 1.5,
    display: 'block',
  },
  portalTask: {
    color: colors.orange,
  },
});

const TaskStatusCardInfoContent = ({
  isInitialTask,
  isTaskPortal,
  status,
  label,
  date,
  user,
  remainingDays,
  overdueDays,
  translateString,
}) => {
  const classes = useStyles();
  const labels = {
    status: 'Status',
    user: isInitialTask ? 'Initiated By' : userLabelByStatus(status),
    date: isInitialTask ? 'Initiated Date' : dateLabelByStatus(status),
    remainingDays: 'Remaining Days',
    overdueDays: 'Days Overdue',
  };

  const formattedInfo = {
    status: translateString(formatStatus(status)),
    user,
    date: formatMoment(date),
    remainingDays,
    overdueDays,
  };

  const infoContentItem = (item) => (
    <Grid item xs={6}>
      <Typography className={classes.field} variant="caption">
        {`${translateString(labels[item])}:`}
      </Typography>
      <Typography className={classes.value} variant="caption">
        {formattedInfo[item]}
      </Typography>
    </Grid>
  );

  return (
    <div className={classes.root}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            className={classNames(classes.label, isTaskPortal ? classes.portalTask : '')}
            variant="caption"
          >
            {label}
          </Typography>
        </Grid>
        {!rUtils.isNilOrEmpty(status) && infoContentItem('status')}
        {!rUtils.isNilOrEmpty(user) && infoContentItem('user')}
        {!rUtils.isNilOrEmpty(date) && infoContentItem('date')}
        {!rUtils.isNilOrEmpty(remainingDays) &&
          remainingDays > 0 &&
          infoContentItem('remainingDays')}
        {!rUtils.isNilOrEmpty(overdueDays) && overdueDays > 0 && infoContentItem('overdueDays')}
      </Grid>
    </div>
  );
};

export default withTranslation(TaskStatusCardInfoContent);
